import { defineMessages } from 'react-intl';
export default defineMessages({
  yes: {
    id: 'component.confirmDialog.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'component.confirmDialog.no',
    defaultMessage: 'No',
  },
});
